/* ============================================
   STAP 2: PREMIUM PRODUCTPAGINA — JS
   Bestand: assets/premium-product-page.js
   ============================================
   Waarom dit de webshop beter maakt:
   Vanilla JS die de CSS hierboven activeert: hover-zoom op
   desktop, fullscreen viewer, sticky add-to-cart die verschijnt
   zodra de originele knop uit beeld scrollt, en een uitklapbare
   FAQ. Geen libraries — licht en snel.
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* --- 1. Hover-zoom op hoofdafbeelding (alleen desktop, volgt muis) --- */
  var mediaWrapper = document.querySelector('.pe-product-media');
  if (mediaWrapper && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var mainImg = mediaWrapper.querySelector('img');
    mediaWrapper.classList.add('pe-zoom-active');

    mediaWrapper.addEventListener('mousemove', function (e) {
      var rect = mediaWrapper.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      mainImg.style.transformOrigin = x + '% ' + y + '%';
      mainImg.style.transform = 'scale(1.8)';
    });

    mediaWrapper.addEventListener('mouseleave', function () {
      mainImg.style.transform = 'scale(1)';
    });

    /* Klik voor fullscreen viewer */
    mediaWrapper.addEventListener('click', function () {
      openLightbox(mainImg.src);
    });
  }

  /* --- 2. Thumbnail-galerij: klik wisselt hoofdafbeelding --- */
  var thumbs = document.querySelectorAll('.pe-thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var newSrc = thumb.getAttribute('data-full-src');
      if (mainImg && newSrc) {
        mainImg.src = newSrc;
      }
      thumbs.forEach(function (t) { t.classList.remove('pe-thumb-active'); });
      thumb.classList.add('pe-thumb-active');
    });
  });

  /* --- 3. Fullscreen lightbox viewer --- */
  var lightbox = document.createElement('div');
  lightbox.className = 'pe-lightbox';
  lightbox.innerHTML = '<button class="pe-lightbox-close" aria-label="Sluiten">&times;</button><img src="" alt="">';
  document.body.appendChild(lightbox);

  var lightboxImg = lightbox.querySelector('img');
  var lightboxClose = lightbox.querySelector('.pe-lightbox-close');

  function openLightbox(src) {
    lightboxImg.src = src;
    lightbox.classList.add('pe-open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.classList.remove('pe-open');
    document.body.style.overflow = '';
  }

  lightboxClose.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) closeLightbox();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLightbox();
  });

  /* --- 4. Sticky Add to Cart: toont zodra originele knop uit beeld is --- */
  var originalAtcButton = document.querySelector('form[action^="/cart/add"] button[type="submit"]');
  var stickyAtc = document.querySelector('.pe-sticky-atc');

  if (originalAtcButton && stickyAtc && 'IntersectionObserver' in window) {
    var atcObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyAtc.classList.remove('pe-visible');
          document.body.classList.remove('pe-has-sticky-atc');
        } else {
          stickyAtc.classList.add('pe-visible');
          document.body.classList.add('pe-has-sticky-atc');
        }
      });
    }, { threshold: 0 });

    atcObserver.observe(originalAtcButton);

    // Sticky-knop triggert de originele form-submit
    var stickyButton = stickyAtc.querySelector('button');
    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        originalAtcButton.click();
      });
    }
  }

  /* --- 5. FAQ accordion --- */
  var faqItems = document.querySelectorAll('.pe-faq-item');
  faqItems.forEach(function (item) {
    var question = item.querySelector('.pe-faq-question');
    var answer = item.querySelector('.pe-faq-answer');

    question.addEventListener('click', function () {
      var isOpen = item.classList.contains('pe-open');

      // Sluit alle andere open items (optioneel: verwijder deze 3 regels voor "meerdere open" gedrag)
      faqItems.forEach(function (other) {
        other.classList.remove('pe-open');
        other.querySelector('.pe-faq-answer').style.maxHeight = null;
      });

      if (!isOpen) {
        item.classList.add('pe-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  /* --- 6. Voorraadindicator: pas class aan bij lage voorraad (via data-attribuut) --- */
  var stockEl = document.querySelector('.pe-stock-indicator');
  if (stockEl) {
    var stockCount = parseInt(stockEl.getAttribute('data-stock-count'), 10);
    if (!isNaN(stockCount) && stockCount > 0 && stockCount <= 10) {
      stockEl.classList.add('pe-low-stock');
    }
  }

});